import { getRequest } from '../../../services/api';

const getServices = async (location, callback) => {
	const services = location
		? await getRequest(`/bookings/service?location=${location}`)
		: await getRequest(`/bookings/service`);

	callback(services);
};

const getSpecialists = async (location, callback) => {
	const specialists = await getRequest(`/bookings/users?role=Clinician`);

	callback(specialists);
};

const getServiceCategories = async (location, callback) => {
	const serviceCategories = await getRequest(`/bookings/serviceCategory`);

	callback(serviceCategories);
};

const getLocationCategories = async (callback) => {
	const locationCategories = await getRequest('/bookings/locationCategory');

	callback(locationCategories);
};

const getMembership = async (customerId, callback) => {
	const membership = await getRequest(`/memberships?userID=${customerId}`);

	callback(membership);
};

const getData = async (location, callback) => {
	const specialists = await getRequest(`/bookings/users?role=Clinician`);
	const services = location
		? await getRequest(`/bookings/service?location=${location}`)
		: await getRequest(`/bookings/service`);
	// const serviceCategoryFilter = location
	// 	? await getRequest(`/bookings/serviceCategory?locationCategory=${location}`)
	// 	: await getRequest(`/bookings/serviceCategory`);
	const serviceCategories = await getRequest(`/bookings/serviceCategory`);
	// TEMP until above fetch Service categroy by location is fix - object returned from the fetch is not in the same structure as object fetch for all service catwegories

	console.log({
		specialists,
		services,
		serviceCategories,
	});

	callback({
		specialists,
		services,
		serviceCategories,
	});
};

export default getData;
export { getServices, getSpecialists, getServiceCategories, getLocationCategories, getMembership };
